import { useRef } from "react";
import { Form, Formik } from "formik";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { ComboBoxChangeEvent, MultiColumnComboBox, } from "@progress/kendo-react-dropdowns";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../messages/en-US";

interface Props {
  onClose: () => void;
  OnLinkReservoir: (reservoidId: string) => void;
  reservoirs: any;
}

export default function LinkReservoirModal(props: Props) {
 
  const localizationService = useLocalization()
  // Guard against duplicate links from rapid double-clicks (dialog stays open
  // during the link request, so it can be triggered again before it closes)
  const hasSubmittedRef = useRef(false);

  const handleSubmit = async (values: any, setStatus: any) => {
    if (hasSubmittedRef.current) return;
    hasSubmittedRef.current = true;
    props.OnLinkReservoir(values.linkReservoir.id);
  };

  const initialValueGenerator = (update: boolean) => {
    return {
    }
  };
  
  
  const columns = [
    { field: "name", header: "Name", width: "300px" },
    { field: "description", header: "Description", width: "300px" },
  ];

  return (
      <div>
        <Dialog title="Link Reservoir" onClose={props.onClose}  >
        <Formik
            onSubmit={async (values, { setStatus }) => {
              await handleSubmit(values, setStatus);
            }}
            initialValues={initialValueGenerator(true)}
          >
            {({ submitForm, values, initialValues, setFieldValue }) => (
              <>
                <Form
                  style={{
                    minWidth: "500px",
                  }}
                >
                  <div className="p-2 w-full">
                    <label htmlFor="linkReservoir">Available Reservoirs</label>

                    <MultiColumnComboBox
                      data={props.reservoirs}
                      columns={columns}
                      textField={"name"}
                      placeholder="Please select ..."
                      onChange={(event: ComboBoxChangeEvent) => setFieldValue("linkReservoir", event.target.value)}
                    />
                  </div>
                </Form>
                <DialogActionsBar>
                  <Button
                    themeColor={"success"}
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    {localizationService.toLanguageString('custom.save', enMessages.custom.save)}
                  </Button>
                  <Button onClick={props.onClose}>{localizationService.toLanguageString('custom.cancel', enMessages.custom.cancel)}</Button>
                </DialogActionsBar>
              </>
            )}
          </Formik>
           
   
        </Dialog>
    </div>
  )
}
